import { useState } from "react";
import api from "../api/api";
import { Eye, EyeOff } from "lucide-react";

export default function Login({ onLogin }) {
const [username, setUsername] = useState("");
const [password, setPassword] = useState("");
const [error, setError] = useState("");
const [showPassword, setShowPassword] = useState(false);

const submit = async (e) => {
e.preventDefault();
setError("");

try {
await api.post("/auth/login", { username, password });
const profile = await api.get("/users/profile");
onLogin(profile.data);
} catch (err) {
setError("Błędny login lub hasło");
}
};

return (
<div className="min-h-screen flex items-center justify-center bg-green-50">
  <form onSubmit={submit} className="bg-white p-8 rounded-xl shadow w-full max-w-sm">
    <div className="flex justify-center mb-6">
      <img src="/images/logo-horizontal.png" alt="GreenData Logo" className="h-16 w-auto" />
    </div>

    {error && <p className="text-red-500 text-center mb-4">{error}</p>}

    <input className="w-full p-2 mb-3 border rounded focus:ring-2 focus:ring-green-500" placeholder="Login"
      value={username} onChange={(e)=> setUsername(e.target.value)}
    />
<div className="relative mb-4">
  <input
    type={showPassword ? "text" : "password"}
    className="w-full p-2 pr-10 border rounded focus:ring-2 focus:ring-green-500"
    placeholder="Hasło"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
  />

  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
  >
    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
  </button>
</div>

    <button type="submit" className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700">
      Logowanie
    </button>
  </form>
</div>
);
}